import type { SelectInputItem } from './SelectInput.vue'

/**
 * Shared type-to-filter predicate for `SelectInputItem`-shaped combobox
 * options. Matches the search term (case-insensitive, trimmed) against each
 * item's `title`, `value`, and optional `searchValue`, returning the subset of
 * `options` (item values) that match. An empty/whitespace term returns every
 * option unchanged.
 *
 * Centralises the filter scaffold shared by `ComboboxSelect`,
 * `InputGroupCombobox`, and the portcall vessel field so the behaviour stays
 * identical across every combobox control.
 *
 * @param items   The full item list backing the combobox.
 * @param options The candidate item values reka-ui asks us to filter.
 * @param term    The raw search term typed by the user.
 */
export function filterSelectInputOptions<TMeta = unknown>(
  items: SelectInputItem<TMeta>[],
  options: string[],
  term: string
): string[] {
  const search = term.toLowerCase().trim()
  if (!search) return options
  return options.filter((val) => {
    const item = items.find((i) => i.value === val)
    if (!item) return false
    return (
      item.title.toLowerCase().includes(search) ||
      item.value.toLowerCase().includes(search) ||
      (item.searchValue?.toLowerCase().includes(search) ?? false)
    )
  })
}
